import components from "./components.js";
import pages from "./pages/index.js";
import wlps from "./wlps.js";

export default {
  apply: "Anwenden",
  asOf: (ctx) => `Stand ${ctx.named("date")}`,
  cancel: "Abbrechen",
  contactUs: "Kontaktieren Sie uns",
  edit: "Bearbeiten",
  error: "Fehler",
  from: "Von",
  ok: "Ok",
  loading: "Laden...",
  logIn: "Anmelden",
  logOut: "Abmelden",
  no: "Nein",
  others: "Andere",
  register: "Registrieren",
  save: "Speichern",
  saving: "Speichern...",
  serverError:
    "Auf unserem Server ist ein Fehler aufgetreten. Ein Bericht wurde an unser Team gesendet und wir werden ihn so schnell wie möglich beheben. Zögern Sie nicht, uns zu kontaktieren, wenn das Problem weiterhin besteht.",
  success: "Erfolg",
  to: "Bis",
  warning: "Warnung",
  yes: "Ja",
  investorProfileTypes: {
    institutional: "Institutioneller Anleger",
    professional: "Professioneller Anleger",
    retail: "Privatanleger",
  },
  layouts: {
    main: {
      admin: {
        listUsers: "Liste der Benutzer",
        platformSettings: "Plattformeinstellungen",
        products: "Produkte",
        sectionName: "Admin",
        holdingDataAdjustments: {
          name: "Bestandsdatenanpassungen",
          categorise: {
            name: "Kategorisieren",
          },
          translate: {
            name: "Übersetzen",
          },
          override: {
            name: "Überschreiben",
          },
        },
        operations: {
          name: "Operationen",
          bulkPriceDataUpdate: {
            name: "Preisdaten aktualisieren",
          },
          generateReports: {
            name: "Berichte generieren",
          },
          bulkComponentsUpdate: {
            name: "Generische Komponenten importieren",
          },
          exports: {
            name: "Exporte",
          },
        },
      },
      help: {
        contact: "Kontakt",
        faq: "FAQ",
        knowledgeBase: "Wissensbasis",
        sectionName: "Hilfe",
      },
      investmentProposal: {
        sectionName: "Investitionsvorschlag",
        reportGenerationSubSectionName: "Berichterstellung",
        weightOptimizationSubSectionName: "Gewichtsoptimierung",
      },
      products: {
        analysis: "Analyse",
        documents: "Dokumente",
        factsheet: "Factsheet",
        overview: "Übersicht",
        sectionName: "Produkte",
        useCase: "Anwendungsfall",
      },
    },
    fullPage: {
      backHome: "Zurück zur Startseite",
    },
    navbar: {
      openInVue3: "Zur neuen Version wechseln",
    },
    profileDropDown: {
      settings: "Einstellungen",
      dialog: {
        adminAsRegularOnMobile: {
          text: "Die Verwaltungsfunktionen sind auf mobilen Geräten nicht verfügbar. Um die Plattform vollständig nutzen zu können, verwenden Sie bitte einen Desktop-Computer. Zu den deaktivierten Verwaltungsfunktionen gehören unter anderem: Bearbeiten von Elementen in der Übersicht, Bearbeiten des Berichts, Hochladen oder Löschen von Dokumenten und Zugriff auf den Verwaltungsbereich.",
          title: "Desktop-Computer für Verwaltungsfunktionen erforderlich",
        },
      },
    },
    theFooter: {
      allRightReserved: "Alle Rechte vorbehalten",
      copyright: "Urheberrecht",
      ombudsman: "Ombudsmann",
      privacyPolicy: "Datenschutzrichtlinie",
      termsOfUse: "Nutzungsbedingungen",
    },
    verticalNavMenu: {
      closeMenuTextWhenEmbedded: "Schliessen",
      errorLoading: "Fehler beim Laden des Menüs",
      openMenuTextWhenEmbedded: "Alle Fonds anzeigen",
    },
    verticalNavMenuGroup: {
      search: "Suche",
      showMore: "Mehr anzeigen",
    },
  },
  perfStats: {
    alpha: "Alpha",
    annualizedReturn: "Annualisierte Rendite",
    annualizedVolatility: "Annualisierte Volatilität",
    annualizedVolatilityDaily: "Annualisierte Volatilität (täglich)",
    averageMonthlyReturns: "Durchschnittliche monatliche Erträge",
    averageNegativeMonthlyReturns: "Durchschnittliche negative monatliche Renditen",
    averagePositiveMonthlyReturns: "Durchschnittliche positive monatliche Renditen",
    beta: "Beta",
    calmarRatio: "Calmar Ratio",
    painRatio: "Pain Ratio",
    painIndex: "Pain-Index",
    correlation: "Korrelation",
    cumulativeReturn: "Kumulative Rendite",
    informationRatio: "Residuales Information Ratio",
    activeInformationRatio: "Aktives Information Ratio",
    kurtosis: "Kurtosis",
    m2RiskAdjustedPerfMonthly: "M2-Messung",
    maxDaysUnderwater: "Maximale Anzahl an Verlusttagen",
    maxMonthsUnderwater: "Maximale Anzahl an Verlustmonaten",
    maxConsecutiveNegativeMonthlyReturns: "Max. aufeinanderfolgende negative monatliche Renditen",
    maxConsecutivePositiveMonthlyReturns: "Max. aufeinanderfolgende positive monatliche Renditen",
    maxNegativeMonthlyReturn: "Maximale negative monatliche Rendite",
    maxPositiveMonthlyReturn: "Maximale positive monatliche Rendite",
    maximumDrawdown: "Maximaler Drawdown",
    maximum: "Maximum",
    minimum: "Minimum",
    omegaRatio: "Omega Ratio",
    ratioOfNegativeMonthlyReturns: "Verhältnis der negativen monatlichen Renditen",
    ratioOfPositiveMonthlyReturns: "Verhältnis der positiven monatlichen Renditen",
    returnToVolatilityRatio: "Rendite-Volatilitäts-Verhältnis",
    sharpeRatio: "Sharpe Ratio",
    skewness: "Schiefe",
    sortinoRatio: "Sortino Ratio",
    trackingError: "Tracking Error",
    treynorRatio: "Treynor Ratio",
    valueAtRiskOnePercentOneMonth: "Value at Risk (VaR) 1% über 1 Monat",
    valueAtRiskFivePercentOneMonth: "Value at Risk (VaR) 5% über 1 Monat",
    valueAtRiskOnePercentTwoWeeks: "Value at Risk (VaR) 1% über 2 Wochen",
    valueAtRiskFivePercentTwoWeeks: "Value at Risk (VaR) 5% über 2 Wochen",
    valueAtRiskOnePercentOneDay: "Value at Risk (VaR) 1% über 1 Tag",
    valueAtRiskFivePercentOneDay: "Value at Risk (VaR) 5% über 1 Tag",
  },
  validations: {
    afterDate: (ctx) =>
      ctx.named("nDaysApart") == 0
        ? `Datum muss nach ${ctx.named("minDate")} liegen (eingeschlossen)`
        : `Datum muss mindestens ${ctx.named("nDaysApart")} Tage nach ${ctx.named("minDate")}`,
    beforeDate: (ctx) =>
      ctx.named("nDaysApart") == 0
        ? `Datum muss vor ${ctx.named("maxDate")} liegen (eingeschlossen)`
        : `Das Datum muss mindestens ${ctx.named("nDaysApart")} Tage vor ${ctx.named("maxDate")}`,
    confirmed: "Das Feld stimmt nicht mit dem vorherigen überein.",
    dateFormat: "Das Datum muss im Format JJJJ-MM-TT angegeben werden.",
    email: "Die E-Mail ist ungültig.",
    maxFileSize: (ctx) =>
      `Die Datei ist größer als die maximal zulässige Größe (${ctx.named("maxSizeMegabytes")} MB).`,
    maxChar: (ctx) => `Das Feld darf nicht mehr als ${ctx.named("length")} Zeichen haben.`,
    minChar: (ctx) => `Das Feld benötigt mindestens ${ctx.named("length")} Zeichen.`,
    minValue: (ctx) => `Der Wert muss größer oder gleich ${ctx.named("min")} sein.`,
    phoneNumber: "Keine gültige Telefonnummer.",
    required: "Dieses Feld ist erforderlich.",
    roleFormat: 'Der Name der Rolle darf das Zeichen ":" nicht enthalten.',
    forbiddenRoleName: "Dieser Rollenname ist reserviert.",
    sum: (ctx) =>
      `Die erwartete Summe beträgt ${ctx.named("expectedValue")} (aktuell: ${ctx.named("currentValue")}).`,
  },
  wlps,
  pages,
  components,
};
